import {FullAddressContactDetailsFragment} from '../../../../gql/graphql';
import {mapNullToUndefined} from '../../../utils/mapperHelper.utils';
import {VatIdModel} from './VatId.model';

export class ContactModel {
  public firstName?: string;
  public lastName?: string;
  public company?: string;
  public phone?: string;
  public vatId?: VatIdModel;

  constructor(params: ContactModel) {
    this.firstName = params.firstName;
    this.lastName = params.lastName;
    this.company = params.company;
    this.phone = params.phone;
    this.vatId = params.vatId;
  }

  public static fromCheckoutV1(contactDetails?: FullAddressContactDetailsFragment | null) {
    if (!contactDetails) {
      return undefined;
    }
    return new ContactModel({
      firstName: mapNullToUndefined(contactDetails.firstName),
      lastName: mapNullToUndefined(contactDetails.lastName),
      company: mapNullToUndefined(contactDetails.company),
      phone: mapNullToUndefined(contactDetails.phone),
      vatId: VatIdModel.fromCheckoutV1(contactDetails.vatId),
    });
  }
}
